/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {ASSETS_ASSET_ROUTE_PROVIDER as ɵi} from './providers/asset-route.provider';
export {ASSET_STATE_TYPES_ASSET_STATE_TYPE_ROUTE_PROVIDER as ɵg} from './providers/asset-state-type-route.provider';
export {ASSET_TYPES_ASSET_TYPE_ROUTE_PROVIDER as ɵf} from './providers/asset-type-route.provider';
export {EQUIPMENTS_EQUIPMENT_ROUTE_PROVIDER as ɵc} from './providers/equipment-route.provider';
export {EVENT_TYPES_EVENT_TYPE_ROUTE_PROVIDER as ɵh} from './providers/event-type-route.provider';
export {LOCATIONS_LOCATION_ROUTE_PROVIDER as ɵe} from './providers/location-route.provider';
export {PROVIDERS_PROVIDER_ROUTE_PROVIDER as ɵd} from './providers/provider-route.provider';
export {INVENTORY_ROUTE_PROVIDERS as ɵa,configureRoutes as ɵb} from './providers/route.provider';